import React from 'react';

import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getLayout } from 'src/layouts/SiteLayout/StaticPageLayout';
import { Paragraph, Subtitle, Title } from 'src/components/common';

const RefundPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="animate__animated animate__fadeIn">
      <Head>
        <title>{t('pages.refundPolicy.title')}</title>
        <meta name="description" content="Generated by create next app" />
      </Head>
      <Title>{t('pages.refundPolicy.title')}</Title>
      <Subtitle>{t('pages.refundPolicy.subtitle')}</Subtitle>
      <Paragraph>{t('pages.refundPolicy.paragraph1')}</Paragraph>
      <Paragraph>{t('pages.refundPolicy.paragraph2')}</Paragraph>
      <Paragraph>{t('pages.refundPolicy.paragraph3')}</Paragraph>
    </div>
  );
};

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

RefundPolicy.getLayout = getLayout;

export default RefundPolicy;
